// Converts the escaped inline renderer output to React nodes; never parses user HTML.
import { createElement } from 'react';
import { Link } from 'react-router-dom';
import { richHtml } from '../../scripts/cms/rich-text.mjs';
const decode = s => s.replace(/&quot;/g, '"').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&amp;/g, '&');
export function inlineNodes(value, options = {}) {
  const html = richHtml(value);
  const top = {children: []}; const stack = [top]; let key = 0;
  for (const token of html.split(/(<\/?(?:strong|em|u|s|a|br)\b[^>]*>)/g)) {
    if (!token) continue;
    if (token.startsWith('</')) {
      if (stack.length < 2) continue;
      const item = stack.pop();
      const props = {key: key++}; let tag = item.tag;
      if (item.tag === 'a') { props.className = options.link; if (item.href.startsWith('/')) { tag = Link; props.to = item.href; } else { props.href = item.href; if (item.href.startsWith('https://')) { props.target = '_blank'; props.rel = 'noopener noreferrer'; } } }
      if (item.tag === 'strong' && typeof options.strong === 'string') props.className = options.strong;
      const node = item.tag === 'strong' && typeof options.strong === 'function' ? options.strong(item.children, props.key) : createElement(tag, props, ...item.children);
      stack.at(-1).children.push(node);
    } else if (token === '<br>') stack.at(-1).children.push(createElement('br', {key:key++}));
    else if (token.startsWith('<')) {
      const tag = /^<([a-z]+)/.exec(token)?.[1]; const href = /href="([^"]*)"/.exec(token)?.[1];
      stack.push({tag, href: href ? decode(href) : undefined, children: []});
    } else stack.at(-1).children.push(decode(token));
  }
  return top.children;
}
export function inlinePlain(value) { return decode(richHtml(value).replace(/<br>/g,'\n').replace(/<[^>]*>/g,'')); }
